import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import th from 'vuetify/es5/locale/th';
import '@mdi/font/css/materialdesignicons.css'
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
    lang: {
      locales: { th },
      current: 'th',
    },
    icons: {
      iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
      values: {
        bookPlus: 'mdi-book-plus',
        bookClock: 'mdi-book-clock',
        bookCheck: 'mdi-book-check',
        pc: 'mdi-desktop-classic',
        xbox: 'mdi-xbox',
        playstation: 'mdi-playstation',
        switch: 'mdi-nintendo-switch',
      },
    }
});